// Copyright 2022-2026 - Hewlett Packard Enterprise Company

import { Spinner } from 'grommet';

const LoadingSpinner = ({ message, ...rest }) => (
  <Spinner
    role="status"
    aria-label={message || 'Loading'}
    message={message || 'Loading'}
    {...rest}
  />
);

export default LoadingSpinner;
